import { useContext, useState } from "react";

import {
  Box,
  Grid,
  Typography,
  Button,
  ButtonBase,
  Popper
} from "@mui/material";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";

import { Autocomplete, LoadingButton } from "@aclymatepackages/atoms";

import CircularProgressWithLabel from "../atoms/loading/CircularProgressWithLabel";

import { AdminDataContext } from "../../helpers/contexts/adminData";
import usePlatformLayoutContext from "../../helpers/contexts/platformLayout";

const AdminSelectCompany = () => {
  const {
    selectedCompany,
    setSelectedCompany,
    selectableCompanies,
    fetchAndSetAdminData,
    isAdminDataLoading
  } = useContext(AdminDataContext);
  const { viewMode, setViewMode } = usePlatformLayoutContext();

  const { id: selectedCompanyId } = selectedCompany || {};

  return (
    <Box p={2}>
      <Grid
        container
        spacing={1}
        justifyContent="center"
        alignItems="center"
        direction="column"
      >
        {!selectableCompanies.length ? (
          <Grid item>
            <CircularProgressWithLabel />
          </Grid>
        ) : (
          <>
            <Grid item container spacing={1} justifyContent="center">
              <Grid item xs={12}>
                <Autocomplete
                  label="Select Company"
                  availableOptions={selectableCompanies}
                  value={selectedCompany}
                  setValue={setSelectedCompany}
                />
              </Grid>
              {!!selectedCompanyId && (
                <Grid item>
                  <Typography variant="body2">
                    {`Selected company ID: ${selectedCompanyId}`}
                  </Typography>
                </Grid>
              )}
            </Grid>
            <Grid
              item
              container
              spacing={2}
              justifyContent="center"
              alignItems="center"
              wrap="nowrap"
            >
              <Grid item>
                <LoadingButton
                  color="primary"
                  label="Fetch Data"
                  disabled={!selectedCompany || !selectedCompanyId}
                  onClick={() => fetchAndSetAdminData()}
                  isLoading={isAdminDataLoading}
                />
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="secondary"
                  disabled={viewMode !== "admin"}
                  onClick={() => {
                    setSelectedCompany({});
                    return setViewMode("company");
                  }}
                >
                  Clear Data
                </Button>
              </Grid>
            </Grid>
          </>
        )}
      </Grid>
    </Box>
  );
};

const AdminSelectCompanyMenu = () => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <ButtonBase onClick={handleClick} style={{ width: "100%" }}>
        <Box px={2} py={0.75} style={{ width: "100%", borderRadius: "10px" }}>
          <Grid container spacing={1} flexWrap="nowrap" alignItems="center">
            <Grid item>
              <Box
                style={{ width: "24px" }}
                display="flex"
                justifyContent="center"
              >
                <AdminPanelSettingsIcon
                  sx={{ color: "text.secondary", fontSize: 20 }}
                />
              </Box>
            </Grid>
            <Grid item>
              <Typography variant="h5" noWrap color="textSecondary">
                Admin
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </ButtonBase>
      <Popper anchorEl={anchorEl} open={open} sx={{ zIndex: 1000 }}>
        <Box
          sx={{
            p: 2,
            bgcolor: "background.paper",
            borderRadius: 1,
            boxShadow: 2
          }}
        >
          <AdminSelectCompany />
        </Box>
      </Popper>
    </>
  );
};
export default AdminSelectCompanyMenu;
